import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import type { GenericDatabasePayload } from '../services/common/common.types';
import type {
    PhysicalTablesRequest,
    TargetTablesBatchBody,
    CreateTableBatchResponse,
    CreateTargetResponse
} from '../services/destination/destination.types';

import destinationService from '../services/destination/destination.service';

/**
 * Create Target Data Source
 */
export const useCreateTargetDataSourceMutation = (
    options?: UseMutationOptions<
        CreateTargetResponse,
        Error,
        GenericDatabasePayload
    >
) => {
    return useMutation<
        CreateTargetResponse,
        Error,
        GenericDatabasePayload
    >({
        mutationFn: destinationService.createTargetDataSource,
        ...options,
    });
};

/**
 * Create Physical Table
 */
export const useCreatePhysicalTableMutation = (
    options?: UseMutationOptions<
        { rows: unknown[] },
        Error,
        PhysicalTablesRequest
    >
) => {
    return useMutation<
        { rows: unknown[] },
        Error,
        PhysicalTablesRequest
    >({
        mutationFn: destinationService.createPhysicalTable,
        ...options,
    });
};

/**
 * Create Target Table Batch
 */
export const useCreateTargetTableBatchMutation = (
    options?: UseMutationOptions<
        CreateTableBatchResponse,
        Error,
        TargetTablesBatchBody
    >
) => {
    return useMutation<
        CreateTableBatchResponse,
        Error,
        TargetTablesBatchBody
    >({
        mutationFn: destinationService.createTargetTableBatch,
        ...options,
    });
};